import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { edabc } from '@/mocks/scale';

export default function Edabc() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            eyebrow="EDABC 网络模型"
            title="五层组织架构，定义网络规模模型"
            subtitle="E-D-A-B-C 五层角色，从千县云总裁到千万车载卡 / 云农人，构成九畴云铺的规模化网络骨架。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 space-y-4">
            {edabc.map((item) => (
              <div
                key={item.code}
                className="flex items-center gap-4 md:gap-6 p-5 rounded-lg bg-foreground-900 border border-foreground-700"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-accent-500 flex items-center justify-center shrink-0">
                  <span className="text-background-50 font-heading font-bold text-xl">
                    {item.code}
                  </span>
                </div>
                <div className="flex-1">
                  <div className="font-medium text-background-50">{item.title}</div>
                  <div className="mt-0.5 text-xs text-foreground-400">{item.desc}</div>
                </div>
                <div className="text-right">
                  <div className="font-heading font-bold text-xl md:text-2xl text-accent-400">
                    {item.count}
                  </div>
                  <div className="text-[10px] text-foreground-400 whitespace-nowrap">规划目标</div>
                </div>
              </div>
            ))}
          </div>

          <p className="mt-6 text-center text-xs text-foreground-500 max-w-3xl mx-auto leading-relaxed">
            注：E-D-A-B-C 五层角色数量均为规划目标 / 网络规模模型，并非已实现的用户规模；实际以项目运营数据为准。
          </p>
        </Reveal>
      </div>
    </section>
  );
}